var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100"},[(
      _vm.media['$v']['source']['$t'] ==
      'Soteria.Models.Attachments.BlobAttachmentSource, Soteria.Models'
    )?_c('div',{staticClass:"h100"},[_c('iframe',{attrs:{"width":"100%","src":_vm.media['$v']['source']['$v']['sourceUrl'],"frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }